import { render } from "./TableNeedApproval.vue?vue&type=template&id=39d66769&scoped=true"
import script from "./TableNeedApproval.vue?vue&type=script&lang=js"
export * from "./TableNeedApproval.vue?vue&type=script&lang=js"

import "./TableNeedApproval.vue?vue&type=style&index=0&id=39d66769&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d66769"]])

export default __exports__